(() => {
  // Read-only snapshot of the Shopify draft product's 34 × 8 variants.
  // This asset intentionally contains technical SKU/ID/price data only.
  const PRICE_CENTS = Object.freeze([4990, 5490, 5990, 6490, 6990, 7490, 7990, 8190]);
  const CODES = Object.freeze([
    'MGF', 'MGA', 'MGD', 'MGB', 'MGE', 'MWG', 'MWR', 'MWM',
    'LOA', 'LOD', 'LOE', 'LOF', 'LOB', 'COA', 'COB', 'COC', 'COD',
    'COE', 'COF', 'LBD', 'LBC', 'LBA', 'MUV', 'MUG', 'MUE', 'MUD',
    'MUC', 'MUP', 'MUN', 'MUT', 'MUL', 'MES', 'BLU', 'DIN'
  ]);
  const START_VARIANT_IDS = Object.freeze([
    '62070395666700', '62070395928844', '62070396190988', '62070396453132',
    '62070396715276', '62070396977420', '62070397239564', '62070397501708',
    '62070397763852', '62070398025996', '62070398288140', '62070398550284',
    '62070398812428', '62070399074572', '62070399336716', '62070399598860',
    '62070399861004', '62070400123148', '62070400385292', '62070400647436',
    '62070400909580', '62070401171724', '62070401433868', '62070401696012',
    '62070401958156', '62070402220300', '62070402482444', '62070402744588',
    '62070403006732', '62070403268876', '62070403531020', '62070403793164',
    '62070404055308', '62070404317452'
  ]);
  const variants = Object.create(null);

  CODES.forEach((code, codeIndex) => {
    for (let tierIndex = 0; tierIndex < PRICE_CENTS.length; tierIndex += 1) {
      const priceTier = `P${String(tierIndex + 1).padStart(2, '0')}`;
      const targetSku = `${code}112-SM-${priceTier}`;
      const variantNumericId = BigInt(START_VARIANT_IDS[codeIndex]) + (BigInt(tierIndex) * 32768n);
      variants[targetSku] = Object.freeze({
        variantId: `gid://shopify/ProductVariant/${variantNumericId}`,
        priceCents: PRICE_CENTS[tierIndex]
      });
    }
  });

  Object.defineProperty(window, 'KK_WAF_PRICE_VARIANTS', {
    configurable: false,
    enumerable: false,
    value: Object.freeze(variants),
    writable: false
  });
})();
